import { render, staticRenderFns } from "./MusculoskeletalTensionExercisesTable.vue?vue&type=template&id=4aa12d6f&scoped=true&"
import script from "./MusculoskeletalTensionExercisesTable.vue?vue&type=script&lang=js&"
export * from "./MusculoskeletalTensionExercisesTable.vue?vue&type=script&lang=js&"
import style0 from "./MusculoskeletalTensionExercisesTable.vue?vue&type=style&index=0&id=4aa12d6f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa12d6f",
  null
  
)

export default component.exports